import "./ScreenSaver.scss";
import ScreenSaverVideo from "../../assets/FESJC_2022_slideshow_v2.mp4";

// Material UI Imports
import { Button, Typography } from "@mui/material";

const Screensaver = () => {
	return (
		<>
			<video autoPlay loop muted className='videoEl'>
				<source src={ScreenSaverVideo} type='video/mp4' />
			</video>
			<Button
				sx={{
					position: "absolute",
					top: "90vh",
					left: "45vw",
					width: "10vw",
					fontSize: "1rem",
					backgroundColor: "rgba(0, 0, 0, 0.65)",
					color: "#fff",
				}}
			>
				<Typography variant='h6' color='primary.contrastText'>
					TOUCH TO START
				</Typography>
			</Button>
		</>
	);
};

export default Screensaver;
